// blog — am. BlogNews page copy.

export default {
  blogEyebrow: 'ግንዘቦችና ዝነዎች',
  blogTitleA: 'ብሎግ',
  blogTitleB: 'እና ዜና',
  blogHeroDesc: 'የድርጅት እድገት፣ ዲጂታል ማስታወቂያ፣ ኢኮመርስ እና የድርጅት ዜናዎች ስለኢትዮጵያ አስተማማኝና ብራንዎች የተዘጋጀ ዝነዎችን ይከታተሉ።',
  blogTabBlog: 'ብሎግ',
  blogTabNews: 'ዜና',
  blogSearchPlaceholder: 'ጽሑፍ ይፈልጉ...',
  blogSortNewest: 'አዲሱው',
  blogSortOldest: 'ቀደሙው',
  blogEmptyTitle: 'ምንም ጽሑፍ አልተገኘም',
  blogEmptyDesc: 'ሌላ ፍለጋ ወይም ሌላ ምድብ ይሞክሩ።',
  blogFeaturedTitle: 'ተመረጡ ጽሑፎች',
  blogMoreTitle: 'ተጨማሪ ጽሑፎች',
  blogCategoriesTitle: 'ምድቦች',
  blogReadMore: 'ተጨማሪ ያንበብክ',
  blogSourceRef: 'የምንጭ ማጣቀሻ ↗',
};